export default __webpack_public_path__ + "4680ae209697bc5bad45e51e4f0f8a09.png";